import tokens from "../../../../tokens.json";

/// A dataset's palette name (e.g. "sky") as its theme's `cat-*` colour, `cat-default` when unknown.
export function resolveDatasetColor(token: string | null | undefined): string {
  return resolvePalette("cat", token);
}

/// The deeper `ring-*` shade: `cat-*` is too pale for a graph ring or link.
export function resolveDatasetRingColor(
  token: string | null | undefined,
): string {
  return resolvePalette("ring", token);
}

function resolvePalette(
  family: "cat" | "ring",
  token: string | null | undefined,
): string {
  const style = getComputedStyle(document.documentElement);
  const name = token && token.length > 0 ? token : "default";
  const resolved = style
    .getPropertyValue(`--token-color-${family}-${name}`)
    .trim();
  return (
    resolved || style.getPropertyValue(`--token-color-${family}-default`).trim()
  );
}

/// `resolveDatasetColor` as a CSS value: no style read, and it follows a theme
/// switch. A name that is not a palette key falls back to the default.
export function datasetColorVar(token: string | null | undefined): string {
  const key = token && /^[a-z0-9-]+$/.test(token) ? token : "default";
  return `var(--token-color-cat-${key}, var(--token-color-cat-default))`;
}

/// A palette name's light-theme color, read from the token source rather than a stylesheet,
/// for surfaces that have none (a favicon).
export function datasetColorLight(token: string | null | undefined): string {
  const colors = tokens.shared.colors as Record<string, { light: string }>;
  return (colors[`cat-${token}`] ?? colors["cat-default"]).light;
}
